import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  name: 'BlindDataOrderActivity',
  data: function data() {
    return {
      activeName: 'first',
      type: 0,
      isSelect: this.checkauthority('blind_data_order_select'),
      selectForm: {
        createTime: null,
        createTimes: [],
        selectCitys: [],
        memberNo: null
      },
      citys: [],
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0
    };
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.createTime = null;
      this.selectForm.createTimes = [];
      this.selectForm.memberNo = null;
      this.selectForm.selectCitys = [];
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                type: _this.type,
                pageNo: _this.pageNo,
                pageSize: _this.pageSize,
                memberNo: _this.selectForm.memberNo,
                cityStr: _this.selectForm.selectCitys
              };
              if (_this.selectForm.createTimes.length >= 2) {
                par.startCreateTime = _this.selectForm.createTimes[0];
                par.endCreateTime = _this.selectForm.createTimes[1];
              }
              _context.n = 1;
              return api.GET_BLINDDATAORDER_USEINFO_PAGE_LIST(par);
            case 1:
              res = _context.v;
              _this.tableData = res.body.datas;
              _this.pageTotal = res.body.sumDataCount;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initCitys: function initCitys() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context2.v;
              _this2.citys = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    initData: function initData() {
      this.initCitys();
      this.initTableData();
    }
  },
  created: function created() {}
};